'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.padLeft = exports.hasTextContents = exports.hasChordContents = exports.pushNew = undefined;

var _chord_lyrics_pair = require('./chord_sheet/chord_lyrics_pair');

var _chord_lyrics_pair2 = _interopRequireDefault(_chord_lyrics_pair);

var _tag = require('./chord_sheet/tag');

var _tag2 = _interopRequireDefault(_tag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pushNew = exports.pushNew = function pushNew(collection, Klass) {
  var newObject = new Klass();
  collection.push(newObject);
  return newObject;
};

var hasChordContents = exports.hasChordContents = function hasChordContents(line) {
  return line.items.some(function (item) {
    return item instanceof _chord_lyrics_pair2.default && item.chords;
  });
};

var hasTextContents = exports.hasTextContents = function hasTextContents(line) {
  return line.items.some(function (item) {
    return item instanceof _chord_lyrics_pair2.default && item.lyrics || item instanceof _tag2.default && item.isRenderable();
  });
};

var padLeft = exports.padLeft = function padLeft(str, length) {
  var paddedString = str;
  for (var l = str.length; l < length; l += 1, paddedString += ' ') {}
  return paddedString;
};


//////////////////
// WEBPACK FOOTER
// ./~/chordsheetjs/lib/utilities.js
// module id = 45
// module chunks = 1